import React, { useEffect } from "react";

export default function DragAndDropSingleFile({ setFile, inputId, inputName, name }) {
    let id = "DropZone";
    useEffect(() => {
        initDragAndDrop();
    }, []);

    const initDragAndDrop = () => {
        let dropZone = document.getElementById(id);
        // Optional. Show the copy icon when dragging over. Seems to only work for chrome.
        dropZone &&
        dropZone.addEventListener("dragover", function (e) {
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = "copy";
        });
        dropZone && dropZone.addEventListener("drop", drop);
    };

    function drop(e) {
        e.stopPropagation();
        e.preventDefault();
        let file = null;
        if (e.target && e.target.files) {
            file = e.target.files[0];
        } else {
            file = e.dataTransfer.files[0];
        }
        setFile(file);
    }

    return (
        <div className="border-block" id={id}>
            <div className="uploading mt-2">
                <a
                    href="#"
                    style={{ color: "#4D9DE7" }}
                    onClick={(e) => {
                        e.preventDefault();
                        document.getElementById(inputId).click();
                    }}
                >
                    {name}
                </a>
                <input
                    onChange={drop}
                    accept="image/png, image/gif, image/jpeg"
                    id={inputId}
                    type="file"
                    name={inputName}
                    style={{ display: "none" }}
                />
            </div>
        </div>
    );
}